import { useCrosswordStore } from '../store'
import { getLettersFromText } from '../lib/pairings'

/**
 * Returns a Set of normalized (uppercase, no spaces) word texts
 * currently placed on the constructor grid.
 */
export function usePlacedWordTexts(): Set<string> {
  const grid = useCrosswordStore(s => s.constructorGrid)
  if (!grid) return new Set()
  const texts = new Set<string>()
  for (const placement of grid.placements) {
    if (placement.wordAText && !placement.wordAText.includes('□')) {
      texts.add(getLettersFromText(placement.wordAText))
    }
    if (placement.wordBText && !placement.wordBText.includes('□')) {
      texts.add(getLettersFromText(placement.wordBText))
    }
  }
  return texts
}

/** Check if a word text is placed on the grid */
export function isWordPlaced(placedTexts: Set<string>, wordText: string): boolean {
  return placedTexts.has(getLettersFromText(wordText))
}
